import { Component, Input, Output, EventEmitter, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ScriptTemplate, CanvasContext } from '../../interfaces/event-script.models';

/**
 * Configurador de variáveis do template selecionado
 */
@Component({
  selector: 'app-template-configurator',
  templateUrl: './template-configurator.component.html',
  styleUrls: ['./template-configurator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TemplateConfiguratorComponent implements OnInit, OnChanges {
  @Input() template: ScriptTemplate | null = null;
  @Input() canvasContext: CanvasContext | null = null;
  @Output() configChanged = new EventEmitter<Record<string, any>>();

  configForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(): void {
    this.buildForm();
  }

  /**
   * Constrói formulário baseado nas variáveis do template
   */
  private buildForm(): void {
    if (!this.template) {
      this.configForm = this.fb.group({});
      return;
    }

    const formConfig: Record<string, any> = {};
    
    this.template.variables.forEach(variable => {
      formConfig[variable.key] = [variable.multiple ? [] : null];
    });

    this.configForm = this.fb.group(formConfig);

    // Emitir mudanças
    this.configForm.valueChanges.subscribe(values => {
      this.configChanged.emit(values);
    });
  }

  /**
   * Obtém opções para uma variável do tipo 'tab'
   */
  getTabOptions(): Array<{ id: string; name: string }> {
    return this.canvasContext?.availableTabs || [];
  }

  /**
   * Obtém opções para uma variável do tipo 'panel'
   */
  getPanelOptions(): Array<{ id: string; name: string }> {
    return this.canvasContext?.availablePanels || [];
  }

  /**
   * Obtém opções para uma variável do tipo 'component'
   */
  getComponentOptions(variable: any): Array<{ id: string; label: string; type: string }> {
    if (!this.canvasContext) {
      return [];
    }

    let fields = this.canvasContext.availableFields;

    // Filtrar por tipo se especificado
    if (variable.componentTypes && variable.componentTypes.length > 0) {
      fields = fields.filter(f => variable.componentTypes.includes(f.type));
    }

    return fields;
  }
}



